// ─── Grille pure : jours × moments ─────────────────────────────────
// N'accède à rien (Firestore, i18n) — reçoit tout par props. `libelleCase`
// transforme une case { recetteId | repasId | libre } en texte affichable
// (résolution des noms faite par l'écran, qui a recettesById/repasById).
//
// JOURS EN LIGNE, MOMENTS EN COLONNE (17/08, demande de Cédric sur capture) :
// il y a TOUJOURS 7 jours mais rarement plus de 2-3 moments (déjeuner/dîner) —
// l'ancien sens (jours en colonne) forçait un défilement horizontal permanent
// pour une grille qui aurait pu tenir en un défilement vertical naturel.
// `cleCaseRepas(jourIdx, momentId)` est indépendante de l'ordre d'affichage :
// transposer le rendu ne touche à AUCUNE donnée stockée.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { useUI } from '@mop/core';
import { JOURS_SEMAINE, cleCaseRepas } from '../services/menus';

const JOURS_COURT = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export default function GrilleMenu({ moments = [], cases = {}, libelleCase, onTapCase }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);

  return (
    <ScrollView horizontal contentContainerStyle={s.scroll}>
      <View>
        <View style={s.ligne}>
          <View style={s.coinJour} />
          {moments.map(mo => (
            <View key={mo.id} style={s.entete}><Text style={s.enteteTxt} numberOfLines={2}>{mo.label}</Text></View>
          ))}
        </View>
        {JOURS_COURT.map((j, ji) => (
          <View key={j} style={s.ligne}>
            <View style={s.jourLbl}><Text style={s.jourTxt}>{j}</Text></View>
            {moments.map(mo => {
              const c = cases[cleCaseRepas(ji, mo.id)] || null;
              return (
                <TouchableOpacity key={mo.id} style={[s.cellule, c && s.celluleRemplie]} activeOpacity={0.7}
                  onPress={() => onTapCase(ji, mo.id)}>
                  <Text style={s.celluleTxt} numberOfLines={3}>{c ? libelleCase(c) : '·'}</Text>
                </TouchableOpacity>
              );
            })}
          </View>
        ))}
      </View>
    </ScrollView>
  );
}

const CELL = 92;
const makeStyles = (UI) => StyleSheet.create({
  scroll: { paddingBottom: 12 },
  ligne: { flexDirection: 'row' },
  coinJour: { width: 64 },
  jourLbl: { width: 64, justifyContent: 'center', paddingRight: 6 },
  jourTxt: { fontSize: 12, fontWeight: '800', color: UI.faint, textTransform: 'uppercase' },
  entete: { width: CELL, alignItems: 'center', justifyContent: 'center', paddingVertical: 6 },
  enteteTxt: { fontSize: 11, fontWeight: '700', color: UI.muted, textAlign: 'center' },
  cellule: { width: CELL, minHeight: 56, margin: 2, borderRadius: 10, borderWidth: 0.5, borderColor: UI.border, backgroundColor: UI.card, alignItems: 'center', justifyContent: 'center', padding: 4 },
  celluleRemplie: { borderColor: UI.accent, backgroundColor: UI.accentTint },
  celluleTxt: { fontSize: 11.5, color: UI.ink, textAlign: 'center', fontWeight: '600' },
});
